import axios from '../../app/axios';
import FlaskApi from '@/services/flask-api'
import Cookies from 'js-cookie';
import io from 'socket.io-client';
import Vue from 'vue';

export const socket = io.connect(process.env.VUE_APP_BASE_URL);

const state = {
  long_term_result_view:{},
  long_term_results:[],
  queue_messages:[]
}

const actions = {

  /**
   * 
   * Send request
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Array } jobs
   */
   postRequestImageComparison({commit,state},payload) {

    return new Promise( (resolve,reject) => {
      return FlaskApi.post(`compare`,payload).then( response => {

        if( response ){

            Vue.toasted.show(response.data.msg, { 
              type: 'success',
              theme: "toasted-primary", 
              position: "top-right", 
              duration : 2500,
            });

            resolve(response.data)

        }
       
        resolve(true)

        }).catch( error => console.error(error))
    }).catch( error => console.error(error))

   },

  /**
   * 
   * Fetch resualts list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Array } jobs
   */
   connectProccessTunnel({commit,state}) {

     socket.on("processing",(message) => {
        commit('setMessages',message.data)
     });

     socket.on("connect",(message) => {
       console.log("Message 1",message)
     });

   },

  /**
   * 
   * Fetch resualts list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Array } jobs
   */
   fetchQueueCompleted({commit,state}, payload) {



   },

  /**
   * 
   * Fetch Long Term resaults
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Array } jobs
   */
   fetchLongTermResults({commit,state}, payload) {
     
     return new Promise( (resolve,reject) => {
       return axios.get(`${process.env.VUE_APP_API_URL}/image-analyst/results`,{ params:payload }).then( response => {

         commit("setLongTermResults", response.data.data);
         resolve(response.data)

       }).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * Fetch Long Term Single resault
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Array } jobs
   */
   fetchLongTermResultView({commit,state}, id) {

     return new Promise( (resolve,reject) => {
       return axios.get(`${process.env.VUE_APP_API_URL}/image-analyst/result/${id}/view`).then( response => {

         commit("setLongTermResultView", response.data.data);

         resolve(response.data)

       }).catch( error => console.log(error))
     }).catch( error => console.log(error))

   },

  /**
   * 
   * Fetch waiting list
   * 
   * @param {State} State
   * @param {Commit} commit 
   * @param {Object} payload 
   * 
   * @return { Array } jobs
   */
   fetchQueueWaiting({commit,state}, payload) {



   },

 }

 const mutations = {

  /**
   * Set completed
   * @param {Object} state 
   * @param {Object} payload 
   */
   setCompleted(state, payload = []) {
     return state.complete = payload
   },

   /**
   * Update process tunnel 
   * @param {Object} state 
   * @param {Object} payload 
   */
   updateProcessTunnel(state, payload = {}) {

     return state.process_tunnel.push({[state.long_term_result_view.id]:payload})

   },

  /**
   * Set completed
   * @param {Object} state 
   * @param {Object} payload 
   */
   setLongTermResults(state, payload = []) {
     return state.long_term_results = payload      
   },

   /**
   * Set completed
   * @param {Object} state 
   * @param {Object} payload 
   */
   setMessages(state, payload = []) {

     if(state.queue_messages.length > 100){
       state.queue_messages.shift()
     }

     return state.queue_messages.push(payload)      
   },

   /**
   * Set completed
   * @param {Object} state 
   * @param {Object} payload 
   */
   setLongTermResultView(state, payload = []) {

     payload.media_analysis_results = payload.media_analysis_results.map( result => {
        return {
           id: result.id,
           created_at: result.created_at,
           data: JSON.parse(result.data),
        }
     })

     return state.long_term_result_view = payload      
   
   },

  /**
   * Set waiting
   * @param {Object} state 
   * @param {Object} payload 
   */
   setWaiting(state, payload = []) {
     return state.waiting = payload
   },


 }

 const getters = {

 }

 export default {

   state,
   mutations,
   actions,
   getters
 }